// Services
export { CookingRecipeService } from './cooking-recipe.service'; // You have to uncomment this, when your real back-end is done
